"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var parser_exports = {};
__export(parser_exports, {
  parseOpenApiSpec: () => parseOpenApiSpec
});
module.exports = __toCommonJS(parser_exports);
var import_js_yaml = require("js-yaml");
var import_sanitize = require("./sanitize");
function parseOpenApiSpec(text) {
  const loaded = loadSpecValue(text);
  if (loaded.error !== void 0) return { error: loaded.error };
  return buildDocument(loaded.value);
}
__name(parseOpenApiSpec, "parseOpenApiSpec");
function loadSpecValue(text) {
  if (looksLikeJson(text)) {
    try {
      return { value: JSON.parse(text) };
    } catch (err) {
      const jsonError = jsonParseError(text, err);
      const asYaml = loadYaml(text);
      return asYaml.error !== void 0 ? { error: jsonError } : asYaml;
    }
  }
  return loadYaml(text);
}
__name(loadSpecValue, "loadSpecValue");
function looksLikeJson(text) {
  const first = text.trim()[0];
  return first === "{" || first === "[";
}
__name(looksLikeJson, "looksLikeJson");
function loadYaml(text) {
  try {
    return { value: (0, import_js_yaml.load)(text, { schema: import_js_yaml.CORE_SCHEMA }) };
  } catch (err) {
    if (err instanceof import_js_yaml.YAMLException) {
      return {
        error: {
          kind: "parse",
          message: err.reason !== "" ? err.reason : err.message,
          // `js-yaml` counts lines from zero, everything shown to a reader counts from one.
          line: err.mark !== void 0 ? err.mark.line + 1 : void 0
        }
      };
    }
    return { error: { kind: "parse", message: errorMessage(err) } };
  }
}
__name(loadYaml, "loadYaml");
function jsonParseError(text, err) {
  const message = errorMessage(err);
  const position = /position (\d+)/.exec(message)?.[1];
  const line = position !== void 0 ? lineAt(text, Number(position)) : void 0;
  return { kind: "parse", message, line };
}
__name(jsonParseError, "jsonParseError");
function lineAt(text, position) {
  let line = 1;
  for (let i = 0; i < position && i < text.length; i++) {
    if (text[i] === "\n") line++;
  }
  return line;
}
__name(lineAt, "lineAt");
function errorMessage(err) {
  return err instanceof Error ? err.message : String(err);
}
__name(errorMessage, "errorMessage");
function buildDocument(value) {
  if (!isRecord(value)) {
    return { error: { kind: "unsupported", message: "The specification is not an object." } };
  }
  const specVersion = asString(value.openapi) ?? (typeof value.openapi === "number" ? String(value.openapi) : void 0);
  if (specVersion === void 0) {
    const swagger = asString(value.swagger);
    if (swagger !== void 0) {
      return {
        error: {
          kind: "unsupported",
          message: `Swagger ${swagger} is not supported, this block reads OpenAPI 3.x.`
        }
      };
    }
    return {
      error: { kind: "unsupported", message: 'Not an OpenAPI document: the "openapi" field is missing.' }
    };
  }
  if (!specVersion.startsWith("3.")) {
    return {
      error: { kind: "unsupported", message: `OpenAPI ${specVersion} is not supported, this block reads OpenAPI 3.x.` }
    };
  }
  const sanitized = (0, import_sanitize.sanitizeOpenApiSpec)(value);
  if (sanitized.overflow) {
    return {
      error: {
        kind: "unsupported",
        message: "The specification is too large or too deeply nested to show."
      }
    };
  }
  const info = isRecord(sanitized.spec.info) ? sanitized.spec.info : {};
  sanitized.spec.openapi = specVersion;
  return {
    document: {
      spec: sanitized.spec,
      specVersion,
      title: asString(info.title) ?? "API",
      version: asString(info.version),
      report: sanitized.report
    }
  };
}
__name(buildDocument, "buildDocument");
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
__name(isRecord, "isRecord");
function asString(value) {
  return typeof value === "string" && value !== "" ? value : void 0;
}
__name(asString, "asString");
//# sourceMappingURL=parser.js.map
